(function ($) {
  $.debounce = function (fn, delay) {
    var timeoutId;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        return fn.apply(context, args);
      }, delay);
      return timeoutId;
    };
  };
})(jQuery);
var mousein = false;
window.header_mouseover = function ($this) {
  if (!mousein) {
    $this.addClass('first-hover');
    mousein = true;
  } else {
    $this.removeClass('first-hover');
  }
  $this.addClass('hover');
};
jQuery(document).ready(function ($) {
  jQuery(document).on('mouseleave', '.xts-nav-main', function () {
    $(this).removeClass('hover');
    $('.menu-item.hover').removeClass('hover');
    mousein = false;
  });
  var display_mega_menu = $.debounce(function (_this) {
    $('.menu-item.hover').removeClass('hover');
    $('#menu-main-menu.first-hover').removeClass('first-hover');
    _this.addClass('hover');
  }, 300);
  jQuery(document).on('mouseover', '.xts-nav-main .menu-item', function () {
    display_mega_menu($(this));
  });
  jQuery('body').on('mouseover', function () {
    if (jQuery('.xts-nav-main .menu-item.hover').length && !jQuery('#menu-main-menu:hover').length) {
      jQuery('.xts-nav-main .menu-item.hover').removeClass('hover');
    }
  });
});